export default __webpack_public_path__ + "static/media/ic_attach.d5b81fdf.svg";